import { useEffect, useState } from "react";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import Spinner from "../Reusable/Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../customHooks/useDebounceHook";
import usePermission from "../../customHooks/usePermission";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

const DeliveryChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    merchantId,
    selectedBranch,
    selectedServiceType,
    id,
  } = props;
  const { data: templateData } = useGetHook({
    queryKey: ["template", id],
    url: `${APIS.DELIVERY_CHARGE_TEMPLATE}${id}/`,
    params: {},
    enabled: !!id,
  });

  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);
  const reportTitle = `${
    selectedServiceType?.name || "Delivery"
  } Charge Report for ${selectedBranch?.name || "Branch"} (${
    templateData?.name
  })`;

  const {
    data: deliveryChargeData,
    isLoading: DeliveryChargeLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      "delivery-charge",
      `delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    url: APIS.DELIVERY_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: localProductType
        ?.map((item: any) => item?.value)
        ?.join(","),
      merchant: merchantId,
      delivery_charge_template: id,
      search: debounceSearch,
    },
  });

  const canUpdateSetting = usePermission({
    allowedPermissions: ["can_update_delivery_charge"],
  });
  console.log(canUpdateSetting, "isSuperUser");

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "delivery",
      `delivery-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    navigateURL: ``,
  });

  const handleDeliveryChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string
  ) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      delivery_charge_template: id,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      merchant: merchantId,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [deliveryChargeData]);

  const handleDownload = () => {
    if (!deliveryChargeData?.body?.length) {
      alert("No data to download");
      return;
    }

    const doc = new jsPDF("landscape");

    const headers = [
      "Destination",
      "Contact",
      "District",
      "Covered Area",
      ...deliveryChargeData.header.map((h: any) => h.name),
    ];

    const rows = deliveryChargeData.body.map((row: any) => [
      row.name,
      row.branch_contact,
      row.district ?? "N/A",
      row.covered_area ?? "N/A",
      ...row.rate,
    ]);

    doc.text(reportTitle, 14, 15);

    autoTable(doc, {
      head: [headers],
      body: rows,
      startY: 20,
      showHead: "firstPage",
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [41, 128, 185],
      },
    });

    doc.save(`delivery_charges_${Date.now()}.pdf`);
  };

  const handleExcelDownload = () => {
    if (!deliveryChargeData?.body?.length) {
      alert("No data to download");
      return;
    }

    const headers = [
      "Destination",
      "Contact",
      "District",
      "Covered Area",
      ...deliveryChargeData.header.map((h: any) => h.name),
    ];

    const rows = deliveryChargeData.body.map((row: any) => [
      row.name,
      row.branch_contact,
      row.district ?? "N/A",
      row.covered_area ?? "N/A",
      ...row.rate,
    ]);

    const worksheetData = [[reportTitle], [], headers, ...rows];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Delivery Charges");

    XLSX.writeFile(workbook, `delivery_charges_${Date.now()}.xlsx`);
  };

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      <div className={tw`w-full flex justify-between items-center mb-2`}>
        <div className={tw`w-52`}>
          <input
            type="text"
            placeholder="Search"
            value={searchQuery ?? ""}
            onChange={(e) => handleSearch(e?.target?.value)}
            className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
          />
        </div>

        <div className={tw`flex gap-2`}>
          <button
            onClick={handleDownload}
            className={tw`px-3 py-1 bg-primary text-white rounded`}
          >
            PDF Dowload
          </button>

          <button
            onClick={handleExcelDownload}
            className={tw`px-3 py-1 bg-green-600 text-white rounded`}
          >
            Excel Download
          </button>
        </div>
      </div>
      {DeliveryChargeLoading || isRefetching ? (
        <Spinner />
      ) : (
        <div className={tw`w-full overflow-x-auto`}>
          <table className={tw`w-full`}>
            <thead className={tw`text-justify`}>
              <tr>
                <th className={tw`pr-12 whitespace-nowrap`}>Destination</th>
                <th className={tw`pr-12 whitespace-nowrap`}> Contact</th>
                <th className={tw`whitespace-nowrap px-8`}> District</th>
                <th className={tw`whitespace-nowrap px-8`}> Covered Area</th>
                {deliveryChargeData?.header?.map((item: any, index: number) => (
                  <th key={`product-type-${item?.id}`}>{item?.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {deliveryChargeData?.body?.map(
                (productType: any, index: number) => (
                  <tr
                    key={`service-city${productType?.location_id}`}
                    className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
                  >
                    <td
                      key={`service-city${productType?.location_id}`}
                      className={tw`py-2`}
                    >
                      {productType?.name}
                    </td>
                    <td
                      className={tw`pr-12 py-2`}
                      key={`service-city${productType?.location_id}`}
                    >
                      {productType?.branch_contact}
                    </td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 uppercase py-2`}
                    >
                      {productType?.district ?? "N/A"}
                    </td>
                    <td
                      key={`service-city-${productType?.location_id}`}
                      className={tw`px-8 uppercase py-2 text-sm`}
                    >
                      {productType?.covered_area ?? "N/A"}
                    </td>
                    {productType?.rate?.map((item: any, index: number) => (
                      <td key={`rate-${index}`}>
                        <input
                          type="text"
                          className={tw`bg-transparent py-2 ${
                            !canUpdateSetting?.isAllowed
                              ? "cursor-not-allowed opacity-60"
                              : ""
                          }`}
                          disabled={!canUpdateSetting?.isAllowed}
                          onBlur={(event: any) =>
                            handleDeliveryChargeChange(
                              productType?.location_id,
                              deliveryChargeData?.header?.[index]?.id,
                              event?.target?.value
                            )
                          }
                          defaultValue={item}
                        />
                      </td>
                    ))}
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DeliveryChargeTable;
